import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { AssignMenuItemCustomizationGroupsRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = AssignMenuItemCustomizationGroupsRequestSchema.strict()

const normalize = fieldNormalizer({
  intList: ['customization_group_ids'],
  assocList: ['customization_groups']
})

export const MenuItemAssignCustomizationGroups = (
  _context: NoContext
): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    const seenIds = new Map<number, number>()
    ;(value.customization_group_ids ?? []).forEach((id) =>
      seenIds.set(id, (seenIds.get(id) ?? 0) + 1)
    )
    ;(value.customization_group_ids ?? []).forEach((id, index) => {
      if ((seenIds.get(id) ?? 0) > 1) {
        issues.addIssue({
          code: 'custom',
          message: 'Duplicate customization groups are not allowed',
          path: ['customization_group_ids', index]
        })
      }
    })

    const seenGroupIds = new Map<number, number>()
    ;(value.customization_groups ?? []).forEach((group) =>
      seenGroupIds.set(group.id, (seenGroupIds.get(group.id) ?? 0) + 1)
    )
    ;(value.customization_groups ?? []).forEach((group, index) => {
      if ((seenGroupIds.get(group.id) ?? 0) > 1) {
        issues.addIssue({
          code: 'custom',
          message: 'Duplicate customization groups are not allowed',
          path: ['customization_groups', index, 'id']
        })
      }
    })
  })
